import Flickity from 'flickity';

const carousels = [];

export default () => {
  const carouselElements = document.querySelectorAll('[data-recent-articles-carousel]');

  if (carouselElements.length === 0) {
    return;
  }

  carouselElements.forEach((el) => {
    const carousel = new Flickity(el, {
      contain: true,
      groupCells: true,
      cellAlign: 'center',
    });

    carousels.push(carousel);

    triggerResize();
  });

  if (document.querySelectorAll('.RecentArticlesCarousel .dot').length <= 1) {
    document.querySelector('.RecentArticlesCarousel .flickity-page-dots').style.display = 'none';
  }
};

function triggerResize() {
  const event = new Event('resize');
  window.dispatchEvent(event);
}
